/** Public files for the test prep chat live in public/test-prep; the app serves them under /df. */
export const asset = (path: string): string => `/df/test-prep/${path}`;

/** The Varsity Tutors logo mark, in its three pieces (public/images), beside an answer in the chat. */
export const markPiece = (piece: 'leftonly' | 'rightonly' | 'reddotonlyonly'): string => `/df/images/varsity-tutors-logomark-${piece}.svg`;
